import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({
  children,
  requireSuperAdmin = false,
  requireNonSuperAdmin = false,
  requireActiveLicense = false,
}) => {
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  const licenseState = useSelector((state) => state.license);
  const isSuperAdmin = user?.isPlatformAdmin === true;
  const isLicenseExpired = licenseState?.isExpired === true;

  // If not logged in, redirect to login
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // If license is expired for business admin, block access
  if (isLicenseExpired && !isSuperAdmin) {
    return <Navigate to="/license-expired" replace />;
  }

  // If route requires super admin but user is not super admin
  if (requireSuperAdmin && !isSuperAdmin) {
    return <Navigate to="/menu/categories" replace />;
  }

  // If route requires non-super admin but user is super admin
  if (requireNonSuperAdmin && isSuperAdmin) {
    return <Navigate to="/businesses" replace />;
  }

  // If route requires active license and license is expired
  if (requireActiveLicense && isLicenseExpired) {
    if (isSuperAdmin) {
      const renewalPath = licenseState?.businessId
        ? `/businesses/${licenseState.businessId}/licenses`
        : "/businesses";
      return <Navigate to={renewalPath} replace />;
    }
    return <Navigate to="/menu/categories" replace />;
  }

  return children;
};

export default ProtectedRoute;
